import { render } from "./MainDrawer.vue?vue&type=template&id=3696440d"
import script from "./js/mainDrawer.js?vue&type=script&lang=js&external"
export * from "./js/mainDrawer.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__